import { useLocation } from "react-router-dom";
import { SINGLE_ARCHIVE_VIEW_NO_ID } from "../enums/UrlPaths";

export default function useCheckPath(pathToCheck = SINGLE_ARCHIVE_VIEW_NO_ID) {
  const location = useLocation();
  const pathWithoutId = location.pathname.split("/").slice(0, -1).join("/") + "/";
  return pathWithoutId === pathToCheck;
}